import { Banner, formatDate } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";

interface OldInvoiceBannerProps {
  date?: Date;
}

export const OldInvoiceBanner = observer(function OldInvoiceBanner(
  props: OldInvoiceBannerProps,
) {
  return (
    <div className="pb-6">
      <Banner
        status="info"
        title={
          <div className="flex items-center">
            <h1 className="text-2xl font-bold">
              <Trans>
                You're editing invoice with older date of supply{" "}
                {props.date && formatDate(props.date)}
              </Trans>
            </h1>
          </div>
        }
      ></Banner>
    </div>
  );
});
